<template>
  <ul class="mode-nav" ref="nav">
    <li
      :class="{active: mode === i}"
      @click="onNavItemClick(i)"
      class="item"
      v-for="(item, i) in navItems"
      v-ripple="'#DA4453'">
      {{ $t('nav.' + item) }}
    </li>
    <div class="indicator" ref="indicator"/>
  </ul>
</template>

<script>
  import { MODES }        from '@/utils/consts'
  import { mapMutations } from 'vuex'

  export default {
    name : 'ModeNav',
    props: {
      mode: {
        type   : String,
        default: 'RELIABILITY'
      }
    },
    data () {
      return {
        navItems: MODES
      }
    },

    mounted () {
      this.$refs.indicator.style.marginLeft = this.navItems.indexOf(this.mode) * 120 + 'px'
    },

    methods: {
      ...mapMutations('context', ['SET_MODE']),
      onNavItemClick (i) {
        this.$refs.indicator.style.marginLeft = i * 120 + 'px'
        this.SET_MODE(MODES[i])
        if (this.$route.name !== MODES[i]) this.$router.push({ name: MODES[i] })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mode-nav {
    @include display-flex(center, flex-start, row);

    .item {
      width       : 120px;
      height      : 100%;
      font-size   : 12px;
      font-weight : 600;
      overflow    : hidden;
      cursor      : pointer;
      position    : relative;
      user-select : none;
      @include display-flex(center, center, row);
      color       : $dark-blue;
      font-family : $primary-font;

      &.active {
        color : $light-red;
      }
    }

    .indicator {
      width      : 120px;
      height     : 3px;
      background : $light-red;
      position   : absolute;
      top        : 0;
      margin-top : 37px;
      transition : margin 0.5s ease;
    }
  }
</style>
